export default __webpack_public_path__ + "static/media/5.d13fa572.png";